/* Helmkennzeichnung112 – sanfter Bildwechsel auf Produktkarten.
   Horizon wechselt beim Hover (zweites Bild) und bei den Farbkreisen hart zum
   neuen Bild. Dieses Skript legt beim Wechsel kurz das alte Bild darüber und
   blendet es weich aus, das neue Bild zoomt minimal herein (Crossfade). */
(() => {
  if (window.__hkxCardFade) return;
  window.__hkxCardFade = true;

  const reduce = window.matchMedia('(prefers-reduced-motion: reduce)');
  const state = new WeakMap(); // slides -> { settled, ghost, timer }
  const DURATION = 450;

  const visibleImg = (slides, left) => {
    const w = slides.clientWidth;
    for (const slide of slides.querySelectorAll('slideshow-slide')) {
      if (slide.hidden) continue;
      if (Math.abs(slide.offsetLeft - left) < w / 2) return slide.querySelector('img');
    }
    return null;
  };

  const settle = (slides, st) => {
    st.settled = slides.scrollLeft;
    st.ghost = null;
    if (st.animated) return void (st.animated = false);
    zoomIn(visibleImg(slides, st.settled));
  };

  const zoomIn = (img) => {
    img?.animate(
      [{ opacity: 0.4, transform: 'scale(1.035)' }, { opacity: 1, transform: 'scale(1)' }],
      { duration: DURATION + 100, easing: 'cubic-bezier(.2,.7,.2,1)' }
    );
  };

  const onScroll = (e) => {
    const slides = e.target;
    if (!(slides instanceof Element) || slides.tagName !== 'SLIDESHOW-SLIDES') return;
    const gallery = slides.closest('product-card .card-gallery');
    if (!gallery || reduce.matches) return;

    let st = state.get(slides);
    if (!st) state.set(slides, (st = { settled: 0, ghost: null, timer: 0 }));

    if (!st.ghost && Math.abs(slides.scrollLeft - st.settled) > 4) {
      const oldImg = visibleImg(slides, st.settled);
      if (oldImg) {
        gallery.querySelectorAll('.hkx-fade-ghost').forEach((n) => n.remove());
        const box = slides.getBoundingClientRect();
        const gbox = gallery.getBoundingClientRect();
        const ghost = oldImg.cloneNode(true);
        ghost.removeAttribute('loading');
        ghost.className = 'hkx-fade-ghost';
        ghost.setAttribute('aria-hidden', 'true');
        ghost.style.cssText = `top:${box.top - gbox.top}px;left:${box.left - gbox.left}px;width:${box.width}px;height:${box.height}px;object-fit:${getComputedStyle(oldImg).objectFit};`;
        gallery.appendChild(ghost);
        st.ghost = ghost;
        ghost.animate([{ opacity: 1 }, { opacity: 0 }], { duration: DURATION, easing: 'ease' }).finished
          .then(() => ghost.remove(), () => ghost.remove());
        // Sofortiger Sprung: neues Bild ist schon da -> direkt mit hereinzoomen
        if (Math.abs(slides.scrollLeft - st.settled) >= slides.clientWidth / 2) {
          zoomIn(visibleImg(slides, slides.scrollLeft));
          st.animated = true;
        }
      }
    }

    // Ende des Wechsels abwarten (sofortiger Sprung oder sanftes Scrollen)
    clearTimeout(st.timer);
    st.timer = setTimeout(() => settle(slides, st), 60);
  };

  document.addEventListener('scroll', onScroll, { capture: true, passive: true });
})();

/* Helmkennzeichnung112 – Fix: Produktbilder bleiben auf Bild 2/3 „hängen“.
   Horizon blättert beim Hover relativ (next() beim Reinfahren, previous() beim
   Rausfahren). Kommt ein Ereignis doppelt oder fehlt eins (Seite lädt unter dem
   Mauszeiger, Zurück-Taste aus dem Browser-Cache, schnelles Drüberfahren), wandert
   das Bild weiter und bleibt auf dem 2. oder 3. Bild stehen. Hier merkt sich jede
   Karte ihr Ausgangsbild und springt beim Rausfahren immer genau dorthin zurück. */
(() => {
  if (window.__hkxCardHoverFix) return;
  window.__hkxCardHoverFix = true;

  const HOME = Symbol('hkxHome');
  const HOVER = Symbol('hkxHover');

  customElements.whenDefined('product-card').then(() => {
    const Card = customElements.get('product-card');
    const proto = Card && Card.prototype;
    if (!proto || proto.__hkxPatched) return;
    proto.__hkxPatched = true;

    const origPreview = proto.previewImage;
    const origReset = proto.resetImage;

    proto.previewImage = function (event) {
      if (event?.pointerType !== 'mouse') return;
      const s = this.refs?.slideshow;
      if (!s) return;
      if (this[HOVER]) return; // schon im Hover – kein zweites Weiterblättern
      this[HOVER] = true;
      if (this[HOME] == null) this[HOME] = s.current ?? 0;
      if (!this.variantPicker) {
        this.resetVariant?.cancel?.();
        const count = s.slides?.length ?? 0;
        if (count > 1) s.select(Math.min(this[HOME] + 1, count - 1), undefined, { animate: false });
        return;
      }
      return origPreview.call(this, event);
    };

    proto.resetImage = function (event) {
      if (event?.pointerType !== 'mouse') return;
      this[HOVER] = false;
      const s = this.refs?.slideshow;
      if (!s) return;
      if (!this.variantPicker) {
        const home = this[HOME] ?? 0;
        if (s.current !== home) s.select(home, undefined, { animate: false });
        return;
      }
      return origReset.call(this, event);
    };
  });

  // Zurück-Taste (Seite aus dem Browser-Cache): alle Karten auf ihr Ausgangsbild
  window.addEventListener('pageshow', (e) => {
    if (!e.persisted) return;
    document.querySelectorAll('product-card').forEach((card) => {
      card[HOVER] = false;
      const s = card.refs?.slideshow;
      if (!s) return;
      const home = card[HOME] ?? 0;
      if (!card.variantPicker && s.current !== home) s.select(home, undefined, { animate: false });
      else if (card.variantPicker) card.resetVariant?.();
    });
  });
})();
